import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { LAST_NAME_SCHEMA_FIELD_NAME } from "./LastNameFormField.schema";

/**
 * LastNameFormField facilitates the input of a last name.
 */

export const LastNameFormField = (props) => {
  const {
    componentProps,
    disabled,
    label = i18n("LastNameFormField__LABEL"),
    name = LAST_NAME_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("LastNameFormField__ARIA"),
        ...componentProps,
      },
      disabled,
      label,
      name,
    };
  }
};

export const lastNameFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

LastNameFormField.propTypes = lastNameFormFieldPropTypes;
